import env from "../app/model/api/env";
import { BaseUrl } from "../utility/constants";

const identityHost: string = env.identityHost;
const clientId: string = env.clientId;
const authority: string = identityHost;
const issuer: string = identityHost;

export const IDENTITY_CONFIG = {
    authority: authority,
    client_id: clientId,
    client_secret: "901564A5-E7FE-42CB-B10D-61EF6A8F3654",
    disablePKCE: false,
    redirect_uri: BaseUrl() + "/signin-oidc",
    silent_redirect_uri: BaseUrl() + "/silentrenew",
    post_logout_redirect_uri: BaseUrl(),
    response_type: "code",
    automaticSilentRenew: false,
    loadUserInfo: true,
    scope: "openid profile email phone roles giving_portal",
};

export const METADATA_OIDC = {
    issuer: issuer,
    jwks_uri: authority + "/.well-known/openid-configuration/jwks",
    authorization_endpoint: authority + "/connect/authorize",
    token_endpoint: authority + "/connect/token",
    userinfo_endpoint: authority + "/connect/userinfo",
    end_session_endpoint: authority + "/connect/logout",
    check_session_iframe: authority + "/connect/checksession",
    revocation_endpoint: authority + "/connect/revocation",
    introspection_endpoint: authority + "/connect/introspect",
    checkSessionIntervalInSeconds: 15,
};
